<template>
    <div>
        <div class="mb-2" v-if="invalidContactInfo" style="color: rgb(var(--vs-danger))">
            At least one method of communication is required.
        </div>
        <div class="flex w-full">
            <vx-phone-input
                class="w-1/2 mr-4"
                :label="'Home Phone'"
                v-model="homePhone"
                remove-validation-padding
                :rules="validatedContactInfo"
            />
            <vx-email-input
                class="w-1/2"
                label="Email Address"
                v-model="emailAddress"
                remove-validation-padding
                :rules="validatedContactInfo"
            />
        </div>
        <div class="flex w-full">
            <vx-phone-input
                class="w-1/2 mr-4"
                :label="'Work Phone'"
                v-model="workPhone"
                remove-validation-padding
                :rules="validatedContactInfo"
            />
            <div class="w-1/2"></div>
        </div>
        <div class="flex w-full">
            <vx-phone-input
                class="w-1/2 mr-4"
                :label="'Mobile Phone'"
                v-model="mobilePhone"
                remove-validation-padding
                :rules="validatedContactInfo"
            />
            <div class="w-1/2"></div>
        </div>
        <vx-divider />
        <vx-address-form v-model="address" />
    </div>
</template>

<script>
export default {
    name: 'patient-contact-info-section',
    props: {
        form: {
            type: Object,
            required: true
        }
    },
    data() {
        return {}
    },
    computed: {
        contact: {
            get() {
                return this.form.contact
            },
            set(v) {
                this.$set(this.form, 'contact', v)
            }
        },
        homePhone: {
            get() {
                return this.contact.homePhone
            },
            set(v) {
                this.$set(this.contact, 'homePhone', v)
            }
        },
        emailAddress: {
            get() {
                return this.contact.emailAddress
            },
            set(v) {
                this.$set(this.contact, 'emailAddress', v)
            }
        },
        workPhone: {
            get() {
                return this.contact.workPhone
            },
            set(v) {
                this.$set(this.contact, 'workPhone', v)
            }
        },
        mobilePhone: {
            get() {
                return this.contact.mobilePhone
            },
            set(v) {
                this.$set(this.contact, 'mobilePhone', v)
            }
        },
        address: {
            get() {
                return this.contact.address
            },
            set(v) {
                this.$set(this.contact, 'address', v)
            }
        },
        invalidContactInfo() {
            return !(
                this.contact.homePhone ||
                this.contact.emailAddress ||
                this.contact.workPhone ||
                this.contact.mobilePhone
            )
        },
        validatedContactInfo() {
            if (this.invalidContactInfo) {
                return ['required']
            }
            return []
        }
    },
    methods: {}
}
</script>

<style lang="scss" scoped></style>
